import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "DocFlow" } });

export const DOC_TYPES = {
  invoice: { label: "Invoice", plural: "Invoices", partyLabel: "Bill To", verb: "Amount Due" },
  quotation: { label: "Quotation", plural: "Quotations", partyLabel: "Prepared For", verb: "Quoted Total" },
  receipt: { label: "Receipt", plural: "Receipts", partyLabel: "Received From", verb: "Amount Received" },
  voucher: { label: "Payment Voucher", plural: "Payment Vouchers", partyLabel: "Paid To", verb: "Amount Paid" },
};

export const STATUSES = {
  invoice: ["draft", "sent", "paid", "void"],
  quotation: ["draft", "sent", "accepted", "void"],
  receipt: ["draft", "paid", "void"],
  voucher: ["draft", "paid", "void"],
};

export const fmtMoney = (n, settings) => {
  const sym = settings?.currency_symbol ?? "";
  const val = Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${sym}${val}`;
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  return isNaN(d) ? s : d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
};

export const computeTotals = (doc) => {
  const subtotal = (doc.items || []).reduce((a, i) => a + Number(i.quantity || 0) * Number(i.unit_price || 0), 0);
  const taxable = Math.max(subtotal - Number(doc.discount || 0), 0);
  const tax_amount = (taxable * Number(doc.tax_rate || 0)) / 100;
  return { subtotal, tax_amount, total: taxable + tax_amount };
};

export const fileUrl = (id, shareToken) =>
  !id ? "" : shareToken ? `${API}/public/files/${shareToken}/${id}` : `${API}/files/${id}`;

export const todayISO = () => new Date().toISOString().slice(0, 10);
